export default __webpack_public_path__ + "media/a87ca980c504429a2babb1d7df82b58338be8497080772c49d872285862100ca.svg";